import { fork } from "redux-saga/effects";

// Transaction Files
import { watchTransactionFileList } from "./Actions/TransactionFileList";
import { watchTransactionFileUpload } from "./Actions/TransactionFileUpload";
import { watchTransactionFileDelete } from "./Actions/TransactionFileDelete";
import { watchTransactionFileData } from "./Actions/TransactionFileData";
import { watchTransactionFilePaymentSetProcessed } from "./Actions/TransactionFilePaymentSetProcessed";
import { watchPaymentSetProcessed } from "./Actions/PaymentSetProcessed";
import { watchTransactionFileUpdate } from "./Actions/TransactionFileUpdate";

// Statuses
import { watchContractStatusesList } from "./Actions/ContractStatusesList";

// Attachment
import { watchAttachmentCreate } from "./Actions/AttachmentCreate";
import { watchAvatarSet } from "./Actions/AvatarSet";
import { watchAttachmentDelete } from "./Actions/AttachmentDelete";
import { watchAttachmentList } from "./Actions/AttachmentList";
import { watchAttachmentDownload} from "./Actions/AttachmentDownload";

// Person
import { watchPersonList } from "./Actions/PersonList";
import { watchPersonCreate } from "./Actions/PersonCreate";
import { watchPersonUpdate } from "./Actions/PersonUpdate";
import { watchPersonDelete } from "./Actions/PersonDelete";
import { watchPersonForPersonDetailsPage } from "./Actions/PersonForPersonDetailsPage";

// Company
import { watchCompanyList } from "./Actions/CompanyList";
import { watchCompanyCreate } from "./Actions/CompanyCreate";
import { watchCompanyUpdate } from "./Actions/CompanyUpdate";
import { watchCompanyDelete } from "./Actions/CompanyDelete";
import { watchCompanyForCompanyDetailsPage } from "./Actions/CompanyForCompanyDetailsPage";
import { watchWithdrawalFromSavingsAccount } from "./Actions/WithdrawalFromSavingsAccount";
import { watchDepositToOwnerSavings } from "./Actions/DepositToOwnerSavings";
import { watchSettleWithSavings } from "./Actions/SettleWithSavings";
import { watchSettleWithSavingsCheckScenario } from "./Actions/SettleWithSavingsCheckScenario";
import { watchSettleWithSavingsPayments } from  "./Actions/SettleWithSavingsPayments";
import { watchSettlePaymentWithSavingsCheckScenario } from "./Actions/SettlePaymentWithSavingsCheckScenario";
import { watchUndoSettleWithSavings } from "./Actions/UndoSettleWithSavings";
import { watchUndoWithdrawalFromSavings } from "./Actions/UndoWithdrawalFromSavings";

// Agency
import { watchAgencyList } from "./Actions/AgencyList";
import { watchGetAgencyList } from "./Actions/AgencySettingsList";
import { watchAgencyUpdate } from "./Actions/AgencyUpdate";

// Address
import { watchAddressList } from "./Actions/AddressList";
import { watchAddressCreate } from "./Actions/AddressCreate";

// Property
import { watchPropertyList } from "./Actions/PropertyList";
import { watchPropertyCreate } from "./Actions/PropertyCreate";
import { watchPropertyUpdate } from "./Actions/PropertyUpdate";
import { watchPropertyDelete } from "./Actions/PropertyDelete";
import { watchPropertyForPropertyDetailsPage } from "./Actions/PropertyForPropertyDetailsPage";

// Unit
import { watchUnitList } from "./Actions/UnitList";
import { watchUnitUpdate } from "./Actions/UnitUpdate";
import { watchUnitCreate } from "./Actions/UnitCreate";
import { watchUnitDelete } from "./Actions/UnitDelete";
import { watchUnitSetActive } from "./Actions/UnitSetActive";
import { watchUnitForUnitDetailsPage } from "./Actions/UnitForUnitDetailsPage";
import { watchUnitServiceStatusUpdate } from "./Actions/UnitServiceStatusUpdate";

// Contract
import { watchContractList } from "./Actions/ContractList";
import { watchContractCreate } from "./Actions/ContractCreate";
import { watchContractUpdate } from "./Actions/ContractUpdate";
import { watchContractDelete } from "./Actions/ContractDelete";
import { watchContractEnd } from "./Actions/ContractEnd";
import { watchContractExpiration } from "./Actions/ContractExpiration";
import { watchContractExtend } from "./Actions/ContractExtend";
import { watchContractForContractDetailsPage } from "./Actions/ContractForContractDetailsPage";
import { watchCreateChargesForNextMounthGetPeriod } from "./Actions/CreateChargesForNextMounthGetPeriod";
import { watchCreateChargesForNextMounth } from "./Actions/CreateChargesForNextMounth";
import { watchCollectiveInvoiceCreate } from "./Actions/CollectiveInvoiceCreate";
import { watchCollectiveInvoiceExistCheck } from "./Actions/CollectiveInvoiceExistCheck";
import { watchContractChangeAutoSendInvoiceAutomatically } from "./Actions/ContractChangeAutoSendInvoiceAutomatically";
import { watchContractSign } from "./Actions/ContractSign";
import { watchContractChangeIsCommercial } from "./Actions/ContractChangeIsCommercial";
import { watchContractPdfCreate } from "./Actions/ContractPdfCreate";

// Charge Template
import { watchChargeTemplateList } from "./Actions/ChargeTemplateList";
import { watchChargeTemplateCreate } from "./Actions/ChargeTemplateCreate";
import { watchChargeTemplateUpdate } from "./Actions/ChargeTemplateUpdate";
import { watchChargeTemplateUpdatePaidDirectlyToOwner } from "./Actions/ChargeTemplateUpdatePaidDirectlyToOwner";
import { watchChargeTemplateDelete } from "./Actions/ChargeTemplateDelete";

// Agency Fee
import { watchAgencyFeeList } from "./Actions/AgencyFeeList";
import { watchAgencyFeeCreate } from "./Actions/AgencyFeeCreate";
import { watchAgencyFeeCreateDefault } from "./Actions/AgencyFeeCreateDefault";
import { watchAgencyFeeUpdateDefault } from "./Actions/AgencyFeeUpdateDefault";
import { watchAgencyFeeUpdate } from "./Actions/AgencyFeeUpdate";
import { watchAgencyFeeDelete } from "./Actions/AgencyFeeDelete";
import { watchAgencyFeeSign } from "./Actions/AgencyFeeSign";
import { watchAgencyFeeEnd } from "./Actions/AgencyFeeEnd";

// Charge
import { watchChargesSaveList } from "./Actions/ChargesSaveList";
import { watchChargesNotSaveList } from "./Actions/ChargesNotSaveList";
import { watchChargeForChargeDetailsPage } from "./Actions/ChargeForChargeDetailsPage";
import { watchChargeDetailsFromLastSimilarPayment } from "./Actions/ChargeDetailsFromLastSimilarPayment";
import { watchChargeCreate } from "./Actions/ChargeCreate";
import { watchChargeUpdate } from "./Actions/ChargeUpdate";
import { watchChargeLink } from "./Actions/ChargeLink";
import { watchChargeUnlink } from "./Actions/ChargeUnlink";
import { watchChargeDelete } from "./Actions/ChargeDelete";
import { watchChargeSettle } from "./Actions/ChargeSettle";
import { watchChargeUnsettle } from "./Actions/ChargeUnsettle";
import { watchChargeTypeCreate } from "./Actions/ChargeTypeCreate";
import { watchChargeTypeUpdate } from "./Actions/ChargeTypeUpdate";
import { watchChargeTypeDelete } from "./Actions/ChargeTypeDelete";
import { watchChargePeriod } from "./Actions/ChargePeriod";
import { watchChargeSnooze } from "./Actions/ChargeSnooze";
import { watchChargeUnrefund } from "./Actions/ChargeUnrefund";
import { watchChargeUndoCredit } from "./Actions/ChargeUndoCredit";
import { watchChargeChangeSent } from "./Actions/ChargeChangeSent";
import { watchChargeCredit } from "./Actions/ChargeCredit";
import { watchChargeCreateInvoicePdf } from "./Actions/ChargeCreateInvoicePdf";
import { watchChargePaidToOwner } from "./Actions/ChargePaidToOwner";
import { watchUndoChargePaidToOwner } from "./Actions/UndoChargePaidToOwner";
import { watchDownloadCharges } from './Actions/DownloadSaga';

// Payment
import { watchPaymentsSaveList } from "./Actions/PaymentsSaveList";
import { watchPaymentsNotSaveList } from "./Actions/PaymentsNotSaveList";
import { watchPaymentForPaymentDetailsPage } from "./Actions/PaymentForPaymentDetailsPage";
import { watchPaymentCreate } from "./Actions/PaymentCreate";
import { watchPaymentUpdate } from "./Actions/PaymentUpdate";
import { watchPaymentUpdateField } from "./Actions/PaymentUpdateField";
import { watchPaymentLink } from "./Actions/PaymentLink";
import { watchPaymentUnlink } from "./Actions/PaymentUnlink";
import { watchPaymentDelete } from "./Actions/PaymentDelete";
import { watchPaymentCreateAndLink } from "./Actions/PaymentCreateAndLink";
import { watchPaymentUnsettle } from "./Actions/PaymentUnsettle";
import { watchPaymentConsiderIncomeForAgency } from "./Actions/PaymentConsiderIncomeForAgency";
import { watchPaymentSnooze } from "./Actions/PaymentSnooze";
import { watchPaymentRefund } from "./Actions/PaymentRefund";
import { watchPaymentCosts } from "./Actions/PaymentCosts";
import { watchGetMatchedChargesList } from "./Actions/PaymentGetMatchedChargesList";
import { watchGetMatchedPaymentsList } from "./Actions/ChargeGetMatchedPaymentsList";

// Settings
import { watchChangePassword } from "./Actions/PasswordChange";
import { watchUserSettingsUpdate } from "./Actions/UserSettingsUpdate";
import { watchAgencySettingsUpdate } from "./Actions/AgencySettingsUpdate";
import { watchFinancialStartDateUpdate } from "./Actions/FinancialStartDateUpdate";
import { watchChangeEmail } from "./Actions/EmailChange";
import { watchChangeEmailConfirm } from "./Actions/EmailChangeConfirm";
import { watchPaymentSettle } from "./Actions/PaymentSettle";

// Email Account
import { watchEmailAccountList } from "./Actions/EmailAccountList";
import { watchEmailAccountCreate } from "./Actions/EmailAccountCreate";
import { watchEmailAccountUpdate } from "./Actions/EmailAccountUpdate";
import { watchEmailAccountDelete } from "./Actions/EmailAccountDelete";
import { watchEmailAccountInActivate } from "./Actions/EmailAccountInActivate";

// Subscription
import { watchSubscriptionList } from "./Actions/SubscriptionList";
import { watchSubscriptionCreate } from "./Actions/SubscriptionCreate";
import { watchSubscriptionDelete } from "./Actions/SubscriptionDelete";

// Event
import { watchEventsSaveList } from "./Actions/EventsSaveList";
import { watchEventForEventDetailsPage } from "./Actions/EventForEventDetailsPage";
import { watchEventCreate } from "./Actions/EventCreate";
import { watchEventUpdate } from "./Actions/EventUpdate";
import { watchEventDelete } from "./Actions/EventDelete";
import { watchEventHide } from "./Actions/EventHide";
import { watchEventSnooze } from "./Actions/EventSnooze";
import { watchRemindersSaveList } from "./Actions/RemindersSaveList";
import { watchNotificationsCount } from "./Actions/NotificationsCount";
import { watchActivitiesCount } from "./Actions/ActivitiesCount";

// Misc
import { watchCheckToken } from "./Actions/CheckToken";
import { watchBalanceFetch } from "./Actions/BalanceFetch";
import { watchSignIn } from "./Actions/Signin";
import { watchSignUp } from "./Actions/Signup";
import { watchSignout } from "./Actions/Signout";
import { watchCheckEmail } from "./Actions/CheckEmail";
import { watchForgotPassword } from "./Actions/ForgotPassword";
import { watchResetPassword } from "./Actions/ResetPassword";
import { watchResendConfirmationMail } from "./Actions/ResendConfirmationMail";
import { watchConfirmAccount } from "./Actions/ConfirmAccount";
import { watchClosePopup } from "./Actions/ClosePopup";
import { watchResendInviteMail } from "./Actions/ResendInviteMail";
import { watchCheckVersion } from "./Actions/CheckVersion";

// Financial Statements
import { watchFinancialStatementsSaveList } from "./Actions/FinancialStatementsSaveList";
import { watchFinancialStatementsNotSaveList } from "./Actions/FinancialStatementsNotSaveList";
import { watchFinancialStatementDownload } from "./Actions/FinancialStatementDownload";
import { watchFinancialStatementData } from "./Actions/FinancialStatementData";
import { watchFinancialStatementLock } from "./Actions/FinancialStatementLock";
import { watchFinancialStatementChangeSent } from "./Actions/FinancialStatementChangeSent";
import { watchFinancialStatementChangeReadinessStatus } from "./Actions/FinancialStatementChangeReadinessStatus";
import { watchStatementSnooze } from "./Actions/StatementSnooze";

// Reports
import { watchReportDownload } from "./Actions/ReportDownload";

// Dashboard
import { watchDashboardFetch } from "./Actions/DashboardFetch";

// IsReadonly
import { watchIsReadonly } from "./Actions/IsReadonly";

// Activity
import { watchActivityTemplateList } from "./Actions/ActivityTemplateList";
import { watchActivityTemplateCreate } from "./Actions/ActivityTemplateCreate";
import { watchActivityTemplateUpdate } from "./Actions/ActivityTemplateUpdate";
import { watchActivityTemplateDelete } from "./Actions/ActivityTemplateDelete";

// Task Template
import { watchTaskTemplateList } from "./Actions/TaskTemplateList";
import { watchTaskTemplateCreate } from "./Actions/TaskTemplateCreate";
import { watchTaskTemplateUpdate } from "./Actions/TaskTemplateUpdate";
import { watchTaskTemplateDelete } from "./Actions/TaskTemplateDelete";

// Task
import { watchUnfinishedTasksCount } from "./Actions/UnfinishedTasksCount";

// Charge Template
import { watchBankAccountList } from "./Actions/BankAccountList";
import { watchBankAccountCreate } from "./Actions/BankAccountCreate";
import { watchBankAccountUpdate } from "./Actions/BankAccountUpdate";
import { watchBankAccountDelete } from "./Actions/BankAccountDelete";

// Ponto
import { watchPonto } from "./Actions/Ponto";

// Mail
import { watchEmailAccountActive } from "./Actions/EmailAccountActive";

//Data Types
import { watchDataTypesList } from "./Actions/DataTypes";

//Email
import { watchEmailSend } from "./Actions/EmailSend";
import { watchLinkSend } from "./Actions/LinkSend";
import { watchGetLoginPortalLink } from "./Actions/GetLoginPortalLink";
import { watchUnsubscribeContractEmail } from "./Actions/ContractEmailUnsubscribe";

//Versions Updates
import { watchVersionsUpdates } from "./Actions/VersionsUpdates";

// Pay Charges
import { watchPayCharges } from "./Actions/PayCharges";

// Conversations
import { watchConversationList } from "./Actions/ConversationList";
import { watchConversationCreate } from "./Actions/ConversationCreate";
import { watchConversationStatusUpdate } from "./Actions/ConversationStatusUpdate";
import { watchConversationNotificationChannelsUpdate } from "./Actions/ConversationNotificationChannelsUpdate";
import { watchConversationReadUpdate } from "./Actions/ConversationReadUpdate";
import { watchMessageCreate } from "./Actions/MessageCreate";
import { watchConversationForConversationDetailsPage } from "./Actions/ConversationForConversationDetailsPage";
import { watchCheckPhoneNumber } from "./Actions/CheckPhoneNumber";
//Token
import { watchCheckTokenUsed } from "./Actions/CheckTokenUsed";
import { watchPaymentRefundCheck } from './Actions/PaymentRefundCheck';

//Process
import { watchStartProcess } from "./Actions/ProcessStart";

export default function* root() {
  yield [
    fork(watchContractStatusesList),
    fork(watchTransactionFileList),
    fork(watchTransactionFileUpload),
    fork(watchTransactionFileDelete),
    fork(watchTransactionFileData),
    fork(watchTransactionFilePaymentSetProcessed),
    fork(watchPaymentSetProcessed),
    fork(watchTransactionFileUpdate),
    fork(watchAvatarSet),
    fork(watchAttachmentCreate),
    fork(watchAttachmentDelete),
    fork(watchPropertyDelete),
    fork(watchUnitDelete),
    fork(watchPropertyUpdate),
    fork(watchUnitCreate),
    fork(watchUnitUpdate),
    fork(watchAddressList),
    fork(watchAddressCreate),
    fork(watchPropertyCreate),
    fork(watchUnitList),
    fork(watchContractList),
    fork(watchContractCreate),
    fork(watchContractUpdate),
    fork(watchContractDelete),
    fork(watchContractEnd),
    fork(watchContractExpiration),
    fork(watchContractExtend),
    fork(watchContractSign),
    fork(watchChargeTemplateList),
    fork(watchChargeTemplateCreate),
    fork(watchChargeTemplateUpdate),
    fork(watchChargeTemplateDelete),
    fork(watchAgencyFeeList),
    fork(watchAgencyFeeCreate),
    fork(watchAgencyFeeCreateDefault),
    fork(watchAgencyFeeUpdateDefault),
    fork(watchAgencyFeeUpdate),
    fork(watchAgencyFeeDelete),
    fork(watchAgencyFeeSign),
    fork(watchAgencyFeeEnd),
    fork(watchChargesSaveList),
    fork(watchChargesNotSaveList),
    fork(watchChargeForChargeDetailsPage),
    fork(watchChargeDetailsFromLastSimilarPayment),
    fork(watchChargeCreate),
    fork(watchChargeUpdate),
    fork(watchEmailSend),
    fork(watchChargeLink),
    fork(watchChargeUnlink),
    fork(watchChargeUnrefund),
    fork(watchChargeUndoCredit),
    fork(watchChargeSettle),
    fork(watchChargeDelete),
    fork(watchPaymentsSaveList),
    fork(watchPaymentsNotSaveList),
    fork(watchPaymentForPaymentDetailsPage),
    fork(watchPaymentCreate),
    fork(watchPaymentCreateAndLink),
    fork(watchPaymentUpdate),
    fork(watchPaymentUpdateField),
    fork(watchPaymentLink),
    fork(watchPaymentUnlink),
    fork(watchPaymentDelete),
    fork(watchPropertyList),
    fork(watchPersonList),
    fork(watchPersonCreate),
    fork(watchPersonUpdate),
    fork(watchPersonDelete),
    fork(watchCompanyList),
    fork(watchCompanyCreate),
    fork(watchCompanyUpdate),
    fork(watchCompanyDelete),
    fork(watchAgencyList),
    fork(watchGetAgencyList),
    fork(watchAgencyUpdate),
    fork(watchChangePassword),
    fork(watchUserSettingsUpdate),
    fork(watchAgencySettingsUpdate),
    fork(watchFinancialStartDateUpdate),
    fork(watchEmailAccountList),
    fork(watchEmailAccountCreate),
    fork(watchEmailAccountUpdate),
    fork(watchEmailAccountDelete),
    fork(watchSubscriptionList),
    fork(watchSubscriptionCreate),
    fork(watchSubscriptionDelete),
    fork(watchEventsSaveList),
    fork(watchRemindersSaveList),
    fork(watchNotificationsCount),
    fork(watchActivitiesCount),
    fork(watchUnfinishedTasksCount),
    fork(watchEventForEventDetailsPage),
    fork(watchEventCreate),
    fork(watchEventUpdate),
    fork(watchEventHide),
    fork(watchEventDelete),
    fork(watchEventSnooze),
    fork(watchCheckToken),
    fork(watchBalanceFetch),
    fork(watchSignIn),
    fork(watchSignUp),
    fork(watchSignout),
    fork(watchCheckEmail),
    fork(watchCheckVersion),
    fork(watchForgotPassword),
    fork(watchResetPassword),
    fork(watchResendConfirmationMail),
    fork(watchResendInviteMail),
    fork(watchConfirmAccount),
    fork(watchClosePopup),
    fork(watchFinancialStatementsSaveList),
    fork(watchFinancialStatementsNotSaveList),
    fork(watchFinancialStatementData),
    fork(watchFinancialStatementDownload),
    fork(watchFinancialStatementLock),
    fork(watchFinancialStatementChangeSent),
    fork(watchFinancialStatementChangeReadinessStatus),
    fork(watchDashboardFetch),
    fork(watchUnitSetActive),
    fork(watchIsReadonly),
    fork(watchActivityTemplateList),
    fork(watchActivityTemplateCreate),
    fork(watchActivityTemplateUpdate),
    fork(watchActivityTemplateDelete),
    fork(watchTaskTemplateList),
    fork(watchTaskTemplateCreate),
    fork(watchTaskTemplateUpdate),
    fork(watchTaskTemplateDelete),
    fork(watchChangeEmail),
    fork(watchChangeEmailConfirm),
    fork(watchBankAccountList),
    fork(watchBankAccountCreate),
    fork(watchBankAccountUpdate),
    fork(watchBankAccountDelete),
    fork(watchEmailAccountInActivate),
    fork(watchEmailAccountActive),
    fork(watchDataTypesList),
    fork(watchChargeTypeCreate),
    fork(watchChargeTypeUpdate),
    fork(watchChargeTypeDelete),
    fork(watchPaymentSettle),
    fork(watchChargeUnsettle),
    fork(watchPaymentUnsettle),
    fork(watchPropertyForPropertyDetailsPage),
    fork(watchUnitForUnitDetailsPage),
    fork(watchContractForContractDetailsPage),
    fork(watchCompanyForCompanyDetailsPage),
    fork(watchPersonForPersonDetailsPage),
    fork(watchVersionsUpdates),
    fork(watchPayCharges),
    fork(watchLinkSend),
    fork(watchPaymentConsiderIncomeForAgency),
    fork(watchWithdrawalFromSavingsAccount),
    fork(watchReportDownload),
    fork(watchDepositToOwnerSavings),
    fork(watchAttachmentList),
    fork(watchUnitServiceStatusUpdate),
    fork(watchSettleWithSavings),
    fork(watchSettleWithSavingsCheckScenario),
    fork(watchAttachmentList),
    fork(watchChargePeriod),
    fork(watchChargeSnooze),
    fork(watchCreateChargesForNextMounthGetPeriod),
    fork(watchCreateChargesForNextMounth),
    fork(watchPaymentSnooze),
    fork(watchPaymentRefund),
    fork(watchPaymentRefundCheck),
    fork(watchPaymentCosts),
    fork(watchCollectiveInvoiceCreate),
    fork(watchCollectiveInvoiceExistCheck),
    fork(watchSettleWithSavingsPayments),
    fork(watchSettlePaymentWithSavingsCheckScenario),
    fork(watchUndoSettleWithSavings),
    fork(watchUndoWithdrawalFromSavings),
    fork(watchConversationCreate),
    fork(watchConversationStatusUpdate),
    fork(watchConversationNotificationChannelsUpdate),
    fork(watchConversationReadUpdate),
    fork(watchMessageCreate),
    fork(watchConversationList),
    fork(watchConversationForConversationDetailsPage),
    fork(watchCheckPhoneNumber),
    fork(watchGetLoginPortalLink),
    fork(watchStatementSnooze),
    fork(watchCheckTokenUsed),
    fork(watchAttachmentDownload),
    fork(watchChargeChangeSent),
    fork(watchChargeCreateInvoicePdf),
    fork(watchContractChangeAutoSendInvoiceAutomatically),
    fork(watchUnsubscribeContractEmail),
    fork(watchChargeCredit),
    fork(watchChargePaidToOwner),
    fork(watchUndoChargePaidToOwner),
    fork(watchChargeTemplateUpdatePaidDirectlyToOwner),
    fork(watchGetMatchedChargesList),
    fork(watchGetMatchedPaymentsList),
    fork(watchContractChangeIsCommercial),
    fork(watchContractPdfCreate),
    fork(watchPonto),
    fork(watchDownloadCharges),
    fork(watchStartProcess),
  ];
}
